export default {
  Color: 'Colour|Colours',
  municipalGroupHeader: 'No Cost Generic Licence Tag',
  personalizePreview: {
    labelOptionsText: "Add your pet's name",
    labelOptionsText2: "Your pet's profile link\nand HomeSafe\u00ae ID\nis automatically included",
    labelOptionsText3: 'Add your contact\nphone number\nOr choose to keep our\n24/7 HomeSafe\u00ae\nhotline number',
    labelPhone: 'Add your contact\nphone number',
    labelProfileLink: "Your pet's profile link and\nHomeSafe\u00ae ID is\nautomatically included",
    labelHotline: 'Our 24/7 HomeSafe\u00ae hotline number',
  },
  basket: {
    noItems: 'No items in your basket',
    licenseTitle: 'Licence and Fees',
    replacementTitle: 'Replacement Tags',
    tagTitle: 'Pet Tags',
    petProductTitle: 'Pet Products And Memberships',
    productTitle: 'Products',
    additionalFeesTitle: 'Additional Fees',
    donationTitle: 'Donations',
    vsTitle: 'Items for Voice & Sight',
    vsPetTitle: 'Pets',
    vsGuardianTitle: 'Pet Owner Or Guardians',
    checkout: 'Checkout',
    continueShopping: 'Continue Shopping',
    shipping: 'Free shipping on all orders over $00.00',
    returnPolicy: 'Something about our return policy',
    warranty: 'Something about our warranty',
    walletCard: {
      title: 'Wallet Cards',
      duplicate: 'Duplicate Wallet Card',
      petIdentification: 'Pet Identification Card',
      missingInfo: 'Your Wallet Card is missing info!',
      finishPet: "Finish {petName}'s card",
      assignPet: 'Assign a pet to your card',
    },
    petTrackerAddedMessaging:
      '<strong>{petName} is so lucky! </strong> Now you can stay connected to his location, health and activity with real-time insights right from your phone.',
  },
  discount: {
    text: 'Promo Code',
    notApplyTip:
      'Promo codes do not apply to pet licensing fees, late fees, replacement pet tags, bundle items or specific sale items.',
    excludesSaleItems: 'Promo Codes cannot be used on Sale items.',
    automatedDiscountBlocksPromo: 'A membership discount is already applied to this order, so promo codes cannot be used.',
  },
  petFooter: {
    chooseTagForNextPet: 'Choose a tag for {petName}',
    addAnotherTag: 'Add a designer tag for {petName}! | Add another designer tag for {petName}!',
  },
  product: {
    nasn: {
      title: "{petName}'s Free Tag",
      subtitle:
        'The Home<em>Safe</em>&reg; aluminum tag is free for all new pets. Just choose a size, and it\'s on its way to you!<span class="nasn-style-header__disclaimer">This is a lifetime tag. Standard fees apply for replacement. Some exceptions related to pet licensing may apply.</span>',
    },
    edit: 'edit',
    remove: 'remove',
    small: 'Small',
    large: 'Large',
    na: 'N/A',
    size: 'Size:',
    color: 'Color:',
    splitRingConnectorInc: 'Split Ring Connector Included',
    personalization: 'Personalization',
    outOfStock: 'Out of Stock',
    addToBasket: 'Add to Basket',
    addTagToBasket: 'Add to Basket',
    updateTag: 'Update Tag',
    addToOrder: 'Add to Order',
    productBundleCallToActionPetUnknown:
      '<span class="text-brand-primary font-weight-bold">SAVE up to {totalSavings}</span> by getting the Pet ID Bundle.',
    productBundleCallToActionPetKnown:
      '<span class="text-brand-primary font-weight-bold">SAVE up to {totalSavings}</span> by getting the Pet ID Bundle for {petName}.',
    productBundleCallToActionLink: 'See details',
    free: 'Free',
  },
  totals: {
    subtotal: 'Subtotal',
    total: 'Total',
    discount: 'Discount',
    shipping: {
      regular: {
        text: 'Regular Mail Shipping',
      },
      priority: {
        upgradeText: 'Upgrade to Priority Shipping ${0}',
        downgradeText: 'Change to Regular Mail Shipping (Free)',
      },
    },
    free: 'FREE',
    tax: 'Tax ({0}) {1}%',
    fees: 'Fees',
    processingFee: 'Processing Fee',
    feesTip: "This fee covers the costs of completing your order.",
    replacementTagFees: 'Replacement tag processing fee',
    replacementTagFeesTip: 'A processing fee is applied to help cover the credit card charges to process your order',
    donation: 'Donation',
  },
  tags: {
    nasn: {
      title: 'This is where protection begins.',
      subtitle: 'A new home. A new tag. A fresh start for {petName}.',
      freeTagReady: "{petName}'s Free Tag is Ready!",
      checkItOut: 'Check it out',
    },
    title:
      'Choose a designer tag and <span class="text-primary">we\'ll donate 20% of the purchase</span> to {cityName}.',
    titleReplacement: 'A designer tag style for {0} is waiting. Browse our collection of over 250 unique styles below.',
    titleSubtext: 'View Best Sellers',
    marketingTop: {
      dyoTag: {
        text: 'Design your own tag!',
        desktop: {
          img: 'https://us.docupet.com/media/uploads/public/system/d9/aa/d9aa3b8771f4f24e36ae293feb71e8d1aa798ccf1f7ab510fd3bb8547ccf2b88.gif',
        },
        mobile: {
          img: 'https://us.docupet.com/media/uploads/public/system/b6/5e/b65ef33448a7d84dfc22f3af87ac4d2ba30052c5f0b972df8668e061c548e9de.gif',
        },
      },
      designerTag: {
        text: 'Designer Tags',
        desktop: {
          img: 'https://us.docupet.com/media/uploads/public/system/88/9a/889ab488fe0a758216585aea5bc6f054e0e94467812a73842f682a4c709ad94b.jpeg',
        },
        mobile: {
          img: 'https://us.docupet.com/media/uploads/public/system/a0/ab/a0ab1a85c92a68ccd6024362a1ccbd53c941068d9f13f8a35c3706c2756e275d.jpeg',
        },
      },
    },
    freeTag: {
      text: {
        default: 'Choose a Standard Aluminum Tag.',
      },
      subtext: 'Available for no cost if this is your pet’s first DocuPet tag.',
    },
    municipalTag: {
      text: {
        admin: 'Standard {0} Tag',
        default: 'Choose a Standard Tag without a donation to {0}.',
        replacementCta: "I don't want a designer tag for {0}",
      },
      subtext: 'Proceed to get a {0} tag',
      priceError: 'Price unavailable',
    },
    placeholderImage: 'tag-placeholder.svg',
  },
  collars: {
    title: 'Choose a collar and <span class="text-primary">we\'ll donate 20% of the purchase</span> to {cityName}.',

    marketingContent: [
      {
        info: 'Two D Rings to separate ID tags and leash',
        img: 'https://us.docupet.com/media/uploads/public/system/13/17/131757981a145a0f5e98eae987afd6445c187bbe4f3fbfdefebdeac9a3a2d5d0.jpeg',
      },
      {
        info: 'Available in four hardware color options',
        img: 'https://us.docupet.com/media/uploads/public/system/6e/74/6e7438ffff03f5a95e245db034cb359db01bf79898561670629983755cf6f7ee.jpeg',
      },
      {
        info: 'Customizable buckle options',
        img: 'https://us.docupet.com/media/uploads/public/system/60/2c/602c33b400fcc65f35bd4bfe7cca842276c68ec36e1a303542606118292c26ea.jpeg',
      },
      {
        info: 'Abrasion and water resistant',
        img: 'https://us.docupet.com/media/uploads/public/system/7f/dc/7fdc02ffadf16ee74af0b752d454701b299e84e0c8e0337f8bb951597ec74bb4.jpeg',
      },
      {
        info: 'Cleans easily',
        img: 'https://us.docupet.com/media/uploads/public/system/2a/01/2a01c2c9c88547220aa1e0fe7090813ff883ef4acd230dd1faa31c700ca673a4.jpeg',
      },
      {
        info: 'Home<em>Safe</em><sup>&reg;</sup> enabled',
        img: 'https://us.docupet.com/media/uploads/public/system/1f/64/1f64b8f662be1335b722bd60aa5dff2c1f6ec0c6562e4b93bad2944f1b196f1d.jpeg',
      },
    ],
    placeholderImage: 'collar-placeholder.svg',
  },
  leashes: {
    title: 'Choose a leash and <span class="text-primary">we\'ll donate 20% of the purchase</span> to {cityName}.',
    marketingContent: [
      {
        info: 'Customizable hardware selection',
        img: 'https://us.docupet.com/media/uploads/public/system/52/af/52aff20462f802a57621388f951fbb7846fd2d640985d53f512319780da5b89a.jpeg',
      },
      {
        info: 'Abrasion and water resistant',
        img: 'https://us.docupet.com/media/uploads/public/system/61/13/611371d3b1347413c33551ef4c3645f86587ab10b43eda3bb024532d03f930fd.jpeg',
      },
      {
        info: 'Cleans easily',
        img: 'https://us.docupet.com/media/uploads/public/system/cb/39/cb39a83cca7dee454b3854438c4d0cd82dcb9c2b71c1aaa68851a04372fa3114.jpeg',
      },
      {
        info: 'Matching collar available',
        img: 'https://us.docupet.com/media/uploads/public/system/fc/59/fc591d579e70563b28c1ea7d5a51a4e1287c154ddd0115a7bbf9a60b8de27bcd.jpeg',
      },
    ],
    placeholderImage: 'leash-placeholder.svg',
  },
  essentials: {
    limitedStock: 'Only {0} left in stock',
    outOfStock: {
      text: 'This product is currently out of stock.',
      linkText: 'Check out the other great products available for your pet.',
    },
    placeholderImage: 'essentials-placeholder.svg',
  },
  marketingBanner: {
    title: {
      default: 'Shop Tags - Where Style Meets Safety',
      licensing: '',
      nonLicensing: 'Shop Tags - Where Style Meets Safety',
      collars: 'Shop strong and functional collars that <span class="text-primary">keep your pet safe</span>',
      leashes: 'Shop strong and functional leashes that <span class="text-primary">keep your pet safe</span>',
      essentials: 'Pet Essentials',
    },
    content: {
      default: [
        {
          info: "All tag styles double as your pet's official licence tag",
        },
        {
          img3x:
            'https://us.docupet.com/media/uploads/public/system/b4/7d/b47d1235b0ac461519c44286b3b8c2761dfa17551389ef6ceac3e5763cf7d8e5.png',
          img2x:
            'https://us.docupet.com/media/uploads/public/system/58/84/58842a92ae3bd300ec3a742f9a2d48e54f952336814b81c822c28baeb3e6a8d2.png',
          img1x:
            'https://us.docupet.com/media/uploads/public/system/93/78/9378c883bb35f6bd749af87e3c054efee797d5aa5becaf978e761d6c1ccbd7ad.png',
          info: "Home<em>Safe</em><sup>&reg;</sup> enabled and linked to your pet's secure online profile",
        },
        {
          img3x:
            'https://us.docupet.com/media/uploads/public/system/4d/c2/4dc29203912492f7396d5cc383f786d56b154343a69edbfcfa03143efb89fedb.png',
          img2x:
            'https://us.docupet.com/media/uploads/public/system/f9/aa/f9aa3a2f5f750fddab95f0024c3445014515d514c9d0c19f9cc686209d0de085.png',
          img1x:
            'https://us.docupet.com/media/uploads/public/system/f2/be/f2beb0b1c6c6ccd16352af06b89da0d3baa6e6707adf30af7b940be36333ffa7.png',
          info: 'Personalization on designer tags - add your pet\u2019s name & phone number',
          qrImage: 'ca/marketing/shop-tags-personalize-qr.png',
        },
      ],
      licensing: [
        {
          info: {
            default:
              "<h1 class='font-weight-bold'>Select a tag for {petName}</h1><h2 class='text-dark'>Any tag style serves as your pet's official licence tag in {cityName}.</h2>",
            admin:
              "<h1 class='font-weight-bold'>Select a tag for {petName}</h1><h2 class='text-dark'>Any DocuPet tag style is recognized as an official licence tag in {cityName}.</h2>",
          },
        },
      ],
      nonLicensing: [
        {
          img3x:
            'https://us.docupet.com/media/uploads/public/system/b4/7d/b47d1235b0ac461519c44286b3b8c2761dfa17551389ef6ceac3e5763cf7d8e5.png',
          img2x:
            'https://us.docupet.com/media/uploads/public/system/58/84/58842a92ae3bd300ec3a742f9a2d48e54f952336814b81c822c28baeb3e6a8d2.png',
          img1x:
            'https://us.docupet.com/media/uploads/public/system/93/78/9378c883bb35f6bd749af87e3c054efee797d5aa5becaf978e761d6c1ccbd7ad.png',
          info: "Home<em>Safe</em><sup>&reg;</sup> enabled and linked to your pet's secure online profile",
        },
        {
          img3x:
            'https://us.docupet.com/media/uploads/public/system/4d/c2/4dc29203912492f7396d5cc383f786d56b154343a69edbfcfa03143efb89fedb.png',
          img2x:
            'https://us.docupet.com/media/uploads/public/system/f9/aa/f9aa3a2f5f750fddab95f0024c3445014515d514c9d0c19f9cc686209d0de085.png',
          img1x:
            'https://us.docupet.com/media/uploads/public/system/f2/be/f2beb0b1c6c6ccd16352af06b89da0d3baa6e6707adf30af7b940be36333ffa7.png',
          info: "Personalize with your pet's name and your phone number",
          qrImage: 'ca/marketing/shop-tags-personalize-qr.png',
        },
        {
          img3x:
            'https://us.docupet.com/media/uploads/public/system/34/cc/34cca01642f509481ec94e6ee0b477d35a4e87dabc3951dde6180e53caf8ff42.png',
          img2x:
            'https://us.docupet.com/media/uploads/public/system/15/cc/15cce9a6de3518176eee667605d84ba33b3564057eba27102aad7ed9bd0bce91.png',
          img1x:
            'https://us.docupet.com/media/uploads/public/system/7f/cd/7fcdb79fddb2f90b55318302669d3f400fdbeef15b78d3d1a41e283b1c3d3b16.png',
          info: 'Our tags always ship for free',
        },
      ],
      collars: [
        {
          img3x:
            'https://us.docupet.com/media/uploads/public/system/34/cc/34cca01642f509481ec94e6ee0b477d35a4e87dabc3951dde6180e53caf8ff42.png',
          img2x:
            'https://us.docupet.com/media/uploads/public/system/15/cc/15cce9a6de3518176eee667605d84ba33b3564057eba27102aad7ed9bd0bce91.png',
          img1x:
            'https://us.docupet.com/media/uploads/public/system/7f/cd/7fcdb79fddb2f90b55318302669d3f400fdbeef15b78d3d1a41e283b1c3d3b16.png',
          info: 'Fast shipping',
        },
        {
          img3x:
            'https://us.docupet.com/media/uploads/public/system/7d/08/7d0883545ef59ba43ae2da2f0461f3ef57c1387f4ca87b88e3ae43d641f56bbc.png',
          img2x:
            'https://us.docupet.com/media/uploads/public/system/cc/71/cc715d3834ab563fa7cb6748c3dd22ab9ecc1eea597ebca73dbf472e94b919f6.png',
          img1x:
            'https://us.docupet.com/media/uploads/public/system/89/d8/89d8b6c3d7deb3a4c698af63e77cc73295899d57e7b2765a57229026666e00ea.png',
          info: "Choose to etch with your pet's Home<em>Safe</em><sup>&reg;</sup> information",
        },
        {
          img3x:
            'https://us.docupet.com/media/uploads/public/system/7d/65/7d65eee31311baa767526fc5a9d280637a30f2b4d22417ed5c6d874ffcaf30f8.png',
          img2x:
            'https://us.docupet.com/media/uploads/public/system/40/25/40258144e24a4b656512ea9bf5ca7a34a3c7612dae17a46b69cc6307682e2a58.png',
          img1x:
            'https://us.docupet.com/media/uploads/public/system/2a/24/2a24e48d49e36d3b26d9babd8c8dec40dd13b0d6dee8c3bd62c71bc10b7fd400.png',
          info: 'Equipped with 2 D-rings to separate ID tags and leash',
        },
      ],
      leashes: [
        {
          img3x:
            'https://us.docupet.com/media/uploads/public/system/34/cc/34cca01642f509481ec94e6ee0b477d35a4e87dabc3951dde6180e53caf8ff42.png',
          img2x:
            'https://us.docupet.com/media/uploads/public/system/15/cc/15cce9a6de3518176eee667605d84ba33b3564057eba27102aad7ed9bd0bce91.png',
          img1x:
            'https://us.docupet.com/media/uploads/public/system/7f/cd/7fcdb79fddb2f90b55318302669d3f400fdbeef15b78d3d1a41e283b1c3d3b16.png',
          info: 'Fast shipping',
        },
        {
          img1x:
            'https://us.docupet.com/media/uploads/public/system/3b/74/3b744ed572ea61f6817ce7dab43649c662b9bee6454c9c62ae85a38b8af69147.png',
          info: 'Available in 4ft or 6ft length',
        },
        {
          img1x:
            'https://us.docupet.com/media/uploads/public/system/a3/6d/a36df3b7cdcd8e49ad70c4425c9c22a9c12f912c484b3845b0ff0f643a38dd44.png',
          info: 'D ring at handle to easily attach accessories',
        },
      ],
      essentials: [
        {
          img3x:
            'https://us.docupet.com/media/uploads/public/system/34/cc/34cca01642f509481ec94e6ee0b477d35a4e87dabc3951dde6180e53caf8ff42.png',
          img2x:
            'https://us.docupet.com/media/uploads/public/system/15/cc/15cce9a6de3518176eee667605d84ba33b3564057eba27102aad7ed9bd0bce91.png',
          img1x:
            'https://us.docupet.com/media/uploads/public/system/7f/cd/7fcdb79fddb2f90b55318302669d3f400fdbeef15b78d3d1a41e283b1c3d3b16.png',
          info: 'Fast shipping',
        },
        {
          img1x:
            'https://us.docupet.com/media/uploads/public/system/c0/7e/c07e1d6618a65debe17a36df9b7be133c9958f7226b3c848e6c525086aef1a6a.png',
          info: 'New products added frequently',
        },
      ],
    },
  },
  otherProductSelect: {
    glowTag: {
      title: 'Add a Glow Tag',
      description: 'Easily spot your pet in the dark with this illuminating sleeve.',
      text: {
        1: 'Add one Glow Tag for ${0}',
        2: 'Add a two-pack for just ${0}',
      },
    },
    keyChain: {
      title: 'Add a matching keychain',
      description:
        "Step aside, friendship bracelets. Commemorate your fur-riendship with a matching keychain. Back side includes your pet's profile link and Home<em>Safe</em><sup>&reg;</sup> ID.",
      text: 'Add a matching keychain for ${0}',
    },
    sizingHelp: 'Sizing Help',
  },
  personalize: {
    title: {
      default: 'Personalize the back of your tag for ${0}',
      admin: 'Does the pet owner want to personalize the back of the tag for ${0}',
      free: 'Personalize the back of your tag for free!',
      adminFree: 'Does the pet owner want to personalize the back of the tag for free?',
    },
    option: {
      default: "Choose to include your pet's name and/or your personal phone number",
      admin: 'Yes',
      error: 'Please select one of the two personalization options.',
      warning: 'The name that you entered does not match your pet name.',
      name: 'Your Phone Number',
    },
  },
  petSelect: {
    personalizationNotMatch:
      'The name that you entered for personalization ({0}) does not match the name of the pet selected.',
  },
  collarPersonalize: {
    title: {
      default: 'Personalize your ID Collar for ${0}',
      admin: 'Personalize your ID Collar for ${0}',
      free: 'Personalize your ID Collar for free!',
    },
    info: {
      default: "Etch your buckle with your pet's Home<em>Safe</em><sup>&reg;</sup> information",
      admin: "Etch your buckle with your pet's Home<em>Safe</em><sup>&reg;</sup> information",
    },
    option: {
      default: 'Personalize my ID Collar with Home<em>Safe</em><sup>&reg;</sup> and contact information',
      admin: 'Yes',
      error: 'Please select your personalization option',
    },
  },
  petHeader: {
    title: {
      default:
        'Choose a <span class="d-none d-sm-inline-block">pawsome&nbsp;</span>tag for <br class="d-sm-none" />\n{petName}',
      editTag: 'Update tag for <br class="d-sm-none" />\n{petName}',
      admin: 'Choose a tag for <br class="d-sm-none" />\n{petName}',
      basket: 'Items for {petName}',
    },
    skipLicensing: {
      text: {
        admin: "This pet's DocuPet Tag is fine. Do not send a new one.",
        default: '{petName} does not need a new tag.',
      },
      linkText: 'Proceed to Checkout',
    },
    for: 'Items for {0}',
  },
  sideBasket: {
    checkoutNow: 'Checkout Now',
    emptyBasket: 'No items in your basket',
    info: "Remember, you'll need to create a DocuPet account to take advantage of the Home<em>Safe</em><sup>&reg;</sup> 24/7 lost pet service.",
    checkout: 'Checkout',
    continueShopping: 'Continue Shopping',
    cancelOrder: 'Cancel Order',
    removeBundleItemConfirmation: {
      title: 'Are you sure you want to remove this item from your basket?',
      message: "This will remove all of the items associated with {petName}'s Pet ID Bundle.",
      messageNoPet: 'This will remove all of the items associated with the Pet ID Bundle.',
      confirmButtonText: 'Yes, remove the item',
      cancelButtonText: 'No, keep this item',
    },
  },
  designFontSelect: {
    title: 'Choose your font',
  },
  designSelect: {
    title: 'Choose your design',
  },
  designText: {
    title: 'Add text to the front of your tag',
  },
  sizeSelect: {
    title: 'Select a Tag Size',
    approxSize: 'Approximate size below',
    small: {
      text: 'Small',
      size: '0.86 in',
    },
    large: {
      text: 'Large',
      size: '1.25 in',
    },
    outOfStock: 'Out of Stock',
    error: 'Select a Tag Size',
  },
  connectorSelect: {
    title: {
      default: 'Choose Your Connector',
      admin: 'Select a Tag Connector',
    },
    info: 'All our tags come with a free split ring connector',
    error: 'Please select a connector',
  },
  productSizeSelect: {
    title: 'Choose your Size',
    approxSize: 'Lengths & widths vary by size',
    XS: {
      text: 'XS',
    },
    S: {
      text: 'S',
    },
    M: {
      text: 'M',
    },
    L: {
      text: 'L',
    },
    XL: {
      text: 'XL',
    },
    outOfStock: 'Out of Stock',
    error: 'Please select a size',
  },
  leashSizeSelect: {
    title: 'Choose your Leash Length',
    approxSize: 'Lengths & widths vary by size',
    outOfStock: 'Out of Stock',
    error: 'Please select a size',
  },
  productInterrupt: {
    actionButton: {
      default: 'Add to Cart',
      oos: 'Out of Stock',
    },
    skipAndContinueButton: {
      default: 'Skip and Continue to Checkout',
      continue: 'Continue to Checkout',
    },
    legalDisclaimer: {
      default:
        '*The Smart Tracker Service is offered as a subscription service that includes a { petTrackingDeviceName } and ' +
        'free companion app. A subscription is required due to the device requiring GPS connectivity via the LTE-M network. The selected term of your subscription commences on the date you submit your order and will ' +
        'automatically renew on the day that is one (1) or two (2) years after the date your subscription commenced, plus' +
        ' one month, to ensure you receive a full one or two year subscription based on the term you selected.' +
        ' To avoid being billed for an additional term, ' +
        'you must cancel your subscription at least 24 hours before the end of your current subscription term.' +
        ' Your subscription may not be transferred to any other person.',
    },
    callToAction: {
      headline: 'Exclusive Offer',
      subtitle: '{petTrackingDeviceName}',
      body: '<strong>Includes Free Shipping and a Free Collar</strong>',
    },
  },
  personalizedWalletCard: {
    style: {
      title: "Customize {0}'s Wallet Card",
      description:
        "Your pet's most important information, conveniently on one card. Upload your pet's photo, include identifying and behavioral details, and be <br class='d-none d-xl-block'/>ready for the unexpected with emergency contact information and a QR code that links to your pet's profile.",
      links: {
        changePet: 'Change who this wallet card is for',
      },
      section: {
        petInfo: {
          title: "Your Pet's Information",
          description: "If you'd like to update any of {0}'s information before customizing their wallet card, you can",
          link: 'edit their details on their profile.',
        },
        petName: {
          title: "Choose How Your Pet's Name Appears",
        },
        poAddress: {
          title: 'Choose How Your Address Appears',
        },
      },
    },
    buttons: {
      next: 'Next',
      edit: 'Edit',
      confirm: 'Confirm',
      remove: 'Remove from Order',
    },
    customize: {
      headline: {
        label: 'Pick Your Headline',
      },
      color: {
        label: 'Pick Your Colour',
      },
      photo: {
        label: "Your Pet's Photo",
        description: "Choose a photo where your pet's face is clearly visible",
        error: 'A photo is required',
      },
      temperament: {
        label: 'Pet Temperament',
      },
      emergency: {
        label: 'Emergency Contact Information',
      },
    },
    custom: {
      front:
        "The front of a customized {color} wallet card features an image of your pet, including details such as pet's name ({name}) breed ({breed}), sex ({sex}), date of birth ({DoB}), coat ({coat}) and temperaments ({temperaments}). It also includes the pet owner's name ({poName}) and the address on file ({address}).",
      back: 'The back of a customized {color} wallet card includes your emergency contact and backup emergency contact information. If emergency contacts are unavailable, call DocuPet at {phone}. Scan the QR code to view your online profile or visit {homeSafeUrl}.',
    },
    preview: {
      title: 'Card Preview',
      description:
        'Everything looks right? Please check this card for spelling and content. Your card will be printed as shown.',
      duplicateTitle: 'Duplicate Cards',
      uploadError:
        "Sorry, we had trouble adding {0}'s wallet card to your order. Please click the 'Confirm' button to try again.",
    },
    productImageAltText: {
      front:
        "The front of a customized wallet card, featuring an example pet's image, name, sex, DOB, colour and temperament; along with it's owners name and address.",
      back: 'The back of a customized wallet card, featuring the pets emergency contact name and numbers, a QR code linking to their DocuPet profile and the docupet emergency phone number.',
    },
  },
  assignProduct: {
    who: 'Who is this for? | Who are these for?',
    select: 'Select the pet for each item you are purchasing.',
  },
  productNotFound: {
    backToStore: '< Back to Store',
    notFound: 'Ooops... product not found!',
    error: 'Ooops... something went wrong!',
    buttons: {
      viewAll: 'View All Products',
      refresh: 'Click to Refresh',
    },
  },
  icons: {
    tags: {
      mobile:
        'https://us.docupet.com/media/uploads/public/system/fb/5f/fb5f55abce17b4f50056853f21469fa139106444a47e626c21dd5a78782fc376.svg',
      desktop:
        'https://us.docupet.com/media/uploads/public/system/43/35/4335faa80a8c095e47b10bd92828858b47d71a4736bb73e4cfd5065c0dc6dc1a.svg',
    },
    collars: {
      mobile:
        'https://us.docupet.com/media/uploads/public/system/80/93/80934877866cefe3277fa66462888e17f4dcd1238bd87154ae8d1b0cd574932e.svg',
      desktop:
        'https://us.docupet.com/media/uploads/public/system/7f/4d/7f4ddb1b97ce71b4118f0ff4de0f204444675de57ac217f0ac5a261fabc4e3aa.svg',
    },
    smartTracker: {
      mobile:
        'https://us.docupet.com/media/uploads/public/system/ca/e2/cae28c1ed7971c8646c9ca9b65e66892ff4b18cd0cda464cc149519486843143.svg',
      desktop:
        'https://us.docupet.com/media/uploads/public/system/ca/e2/cae28c1ed7971c8646c9ca9b65e66892ff4b18cd0cda464cc149519486843143.svg',
    },
    walletCards: {
      mobile:
        'https://us.docupet.com/media/uploads/public/system/a9/ca/a9ca2863d47f15fe877673584a09cbab0df5da92f2bef3e244e0f954a9f804ef.png',
      desktop:
        'https://us.docupet.com/media/uploads/public/system/a9/ca/a9ca2863d47f15fe877673584a09cbab0df5da92f2bef3e244e0f954a9f804ef.png',
    },
    essentials: {
      mobile:
        'https://us.docupet.com/media/uploads/public/system/18/d9/18d9e17ab5730b8cf42dcf48464c4ba3f0099b5d30f0be63f33f8ab1a31a06f6.svg',
      desktop:
        'https://us.docupet.com/media/uploads/public/system/61/e9/61e9dd92712e411e4adcd00e7067b13ae8313eefd605fcde7c23978f5318267f.svg',
    },
  },
  walletCardProduct: {
    title: 'Customize Wallet Card',
    productImageLabel: {
      front: 'Front',
      back: 'Back',
    },
    petSelect: {
      title: 'Who is this for?',
      options: {
        default: 'Who is this wallet card for?',
        addNew: 'Add another pet',
      },
    },
    buttons: {
      next: {
        wPet: 'Customize Wallet Card for {0}',
        default: 'Customize Wallet Card for Pet',
      },
    },
  },
  productConfigBackLink: {
    Back: '< Back',
    StoreForPet: '< Back to Tags',
    TagStore: '< Back to Tags',
    PetTagLoop: '@:productConfigBackLink.TagStore',
    CollarStore: '< Back to ID Collars and Leashes',
    LeashStore: '@:productConfigBackLink.CollarStore',
    EssentialsStore: '< Back to Pet Essentials',
    WalletCardStore: '< Back to Wallet Cards',
    ContinueToLicensing: '< Back to @:dp.navbar.licensing',
    Basket: '< Back to Basket',
    ProductInterrupt: '@:productConfigBackLink.Back',
    Store: '@:productConfigBackLink.Back',
  },
  errorMessages: {
    defaultRequired: 'The {field} is required',
    adminRelation: 'Please select the relationship with your Administrative Contact',
    adminLastName: 'Please enter the last name of your Administrative Contact',
    adminFirstName: 'Please enter the first name of your Administrative Contact',
  },
};
